import React, { createContext, useContext, useMemo } from 'react';
import { useProgressAnimation } from '../../hooks/progress';
const ProgressLoaderContext = /*#__PURE__*/createContext(null);
export function ProgressLoaderProvider(_ref) {
  let {
    isLoading,
    totalCount = 20,
    progressUpdateInterval = 100,
    countUpdateInterval = 200,
    progressIncrement = 2,
    countIncrement = 1,
    statusMessageCount = 1,
    onAnimationComplete,
    children
  } = _ref;
  const animationState = useProgressAnimation({
    isLoading,
    totalCount,
    progressUpdateInterval,
    countUpdateInterval,
    progressIncrement,
    countIncrement,
    statusMessageCount,
    onAnimationComplete
  });
  const value = useMemo(() => ({
    ...animationState,
    isLoading,
    totalCount
  }), [animationState.progress, animationState.count, animationState.isAnimationComplete, animationState.statusMessageIndex, isLoading, totalCount]);
  return /*#__PURE__*/React.createElement(ProgressLoaderContext.Provider, {
    value: value
  }, children);
}
export function useProgressLoader() {
  const context = useContext(ProgressLoaderContext);
  if (!context) {
    throw new Error('useProgressLoader must be used within ProgressLoaderProvider');
  }
  return context;
}
//# sourceMappingURL=ProgressLoaderProvider.js.map